export default {
  title: {
    id: 'buyback_refurbisher_csv_modal_title',
    defaultMessage: 'Import or export CSV file',
  },
  importStepTitle: {
    id: 'buyback_refurbisher_csv_modal_import_title',
    defaultMessage: 'Import listings',
  },
  exportStepTitle: {
    id: 'buyback_refurbisher_csv_modal_export_title',
    defaultMessage: 'Export listings',
  },
  importStepCta: {
    id: 'buyback_refurbisher_csv_modal_import_cta',
    defaultMessage: 'Import file',
  },
  exportStepCta: {
    id: 'buyback_refurbisher_csv_modal_export_cta',
    defaultMessage: 'Export file',
  },
  choiceStepImportTitle: {
    id: 'buyback_refurbisher_csv_modal_choice_import',
    defaultMessage: 'Import',
  },
  choiceStepExportTitle: {
    id: 'buyback_refurbisher_csv_modal_choice_export',
    defaultMessage: 'Export',
  },
  choiceStepImportMessage: {
    id: 'buyback_refurbisher_csv_modal_choice_import_message',
    defaultMessage:
      'Upload a CSV file to import new listings or update existing ones',
  },
  choiceStepExportMessage: {
    id: 'buyback_refurbisher_csv_modal_choice_export_message',
    defaultMessage: 'Export a CSV file of existing listings',
  },
  exportStepMessage: {
    id: 'buyback_refurbisher_csv_modal_export_message',
    defaultMessage:
      'Heads up: Your exported CSV file won’t include any of the search filters you originally applied.',
  },
  importStepMessage: {
    id: 'buyback_refurbisher_csv_modal_import_message',
    defaultMessage: 'Upload a CSV file formatted in {count} separate columns:',
  },
  importStepExample: {
    id: 'buyback_refurbisher_csv_modal_import_example',
    defaultMessage: 'Download an example CSV file',
  },
  encodingLabel: {
    id: 'buyback_refurbisher_csv_modal_import_encoding_label',
    defaultMessage: 'Encoding',
  },
  csvFileLabel: {
    id: 'buyback_refurbisher_csv_modal_import_csv_file_label',
    defaultMessage: 'Add CSV file',
  },
  delimiterLabel: {
    id: 'buyback_refurbisher_csv_modal_import_delimiter_label',
    defaultMessage: 'Delimiter',
  },
  faqLink: {
    id: 'buyback_refurbisher_csv_modal_import_learn_more_button',
    defaultMessage: 'Learn how to create or update listings with CSV files',
  },
  required: {
    id: 'buyback_shared_required_field',
    defaultMessage: 'This field is required',
  },
}
